var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5602 11.8216L21.4002 11.6016C21.1202 11.2616 20.7902 10.9916 20.4102 10.7916C19.9002 10.5016 19.3202 10.3516 18.7202 10.3516H6.2702C5.6702 10.3516 5.1002 10.5016 4.5802 10.7916C4.1902 11.0016 3.8402 11.2916 3.5502 11.6516C2.9802 12.3816 2.7102 13.2816 2.8002 14.1816L3.1702 18.8516C3.3002 20.2616 3.4702 22.0016 6.6402 22.0016H18.3602C21.5302 22.0016 21.6902 20.2616 21.8302 18.8416L22.2002 14.1916C22.2902 13.3516 22.0702 12.5116 21.5602 11.8216ZM14.8902 17.3416H10.1002C9.7102 17.3416 9.4002 17.0216 9.4002 16.6416C9.4002 16.2616 9.7102 15.9416 10.1002 15.9416H14.8902C15.2802 15.9416 15.5902 16.2616 15.5902 16.6416C15.5902 17.0316 15.2802 17.3416 14.8902 17.3416Z",
    fill: "#FF1C26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.061 8.59643C21.0986 8.97928 20.6833 9.23561 20.3185 9.11348C19.8137 8.94449 19.2824 8.86 18.7299 8.86H6.26988C5.71304 8.86 5.16478 8.95012 4.65322 9.12194C4.29283 9.24298 3.87988 8.99507 3.87988 8.61489V6.66C3.87988 3.09 4.96988 2 8.53988 2H9.71988C11.1499 2 11.5999 2.46 12.1799 3.21L13.3799 4.81C13.6299 5.15 13.6399 5.17 14.0799 5.17H16.4599C19.5856 5.17 20.8069 6.00724 21.061 8.59643Z",
    fill: "#FF1C26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.b7b25b6cc9d1b6399a136e87e5d3305d.svg";
export { ForwardRef as ReactComponent };